export const FALLBACK_COORDINATE_SYSTEMS = [
  { code: 'WGS84', name: 'WGS84 (GPS标准)' },
  { code: 'GCJ02', name: 'GCJ02 (火星坐标系)' },
  { code: 'BD09', name: 'BD09 (百度坐标系)' },
  { code: 'CGCS2000', name: 'CGCS2000 (中国大地坐标系)' }
];

export const FALLBACK_OUTPUT_FORMATS = [
  { code: 'DD', name: '十进制度' },
  { code: 'DM', name: '度分格式' },
  { code: 'DMS', name: '度分秒格式' }
];

export const DEFAULT_MAP_CENTER = [119.13643, 28.07741];
